import ImageType from "components/Content/RelatedArticles/PropTypes/ImageType";
import ImgixImg from "components/Content/RelatedArticles/ImgixImg";
import LazyLoad from "react-lazyload";
import PropTypes from "prop-types";
import React from "react";

const LAZY_LOAD_OFFSET = 100;

export default function Figure({
  articleUrl,
  image: { src },
}) {
  return (
    <figure>
      <a href={articleUrl}>
        <LazyLoad once offset={LAZY_LOAD_OFFSET}>
          <ImgixImg src={src} />
        </LazyLoad>
      </a>
    </figure>
  );
}

Figure.propTypes = {
  articleUrl: PropTypes.string.isRequired,
  image: ImageType.isRequired,
};
